<rappider-title-toolbar [mainTitle]="mainTitle"
                        [options]="title"
                        [displayToolbar]="displayToolbar"
                        [displayToolbarBackButton]="displayToolbarBackButton"
                        [displayBreadcrumb]="displayBreadcrumb"></rappider-title-toolbar>

<div class="add-data-event-button">
  <rappider-button *ngIf="addDataEventButtonVisibility"
                   [text]="addDataEventButtonConfig.text"
                   [size]="addDataEventButtonConfig.size"
                   [block]="addDataEventButtonConfig.block"
                   [icon]="addDataEventButtonConfig.icon"
                   (click)="onAddDataEventToUiStepFunction()"></rappider-button>
</div>

<rappider-spin [spinning]="loading || !isFormBuilt">
  <form *ngIf="isFormBuilt"
        nz-form
        [formGroup]="editUIStepFunctionForm"
        [nzLayout]="formLayout"
        (ngSubmit)="onEditUiWorkflowStepFunction()">

    <!-- UI Data Store -->
    <nz-form-item>
      <nz-form-label nzRequired
                     [nzSpan]="calculateFormLayout().label">
        {{ 'SHARED.UI_DATA_STORE' | translate }}
      </nz-form-label>
      <nz-form-control [nzErrorTip]="requiredErrorTemplate"
                       [nzSpan]="calculateFormLayout().input">
        <rappider-select [options]="uiDataStoreSelectOptions"
                         [disabled]="editUIStepFunctionForm?.get('uiDataStore').disabled"
                         formControlName="uiDataStore"></rappider-select>
      </nz-form-control>
    </nz-form-item>

    <!-- Name -->
    <nz-form-item>
      <nz-form-label nzRequired
                     [nzSpan]="calculateFormLayout().label">
        {{ 'SHARED.NAME' | translate }}
      </nz-form-label>
      <nz-form-control [nzErrorTip]="nameFieldErrorTemplates"
                       [nzSpan]="calculateFormLayout().input">
        <rappider-textbox formControlName="name"
                          (ngModelChange)="onNameChange($event)"></rappider-textbox>
      </nz-form-control>
    </nz-form-item>

    <!-- Subscribed Events -->
    <nz-form-item>
      <nz-form-label nzRequired
                     [nzSpan]="calculateFormLayout().label">
        {{ 'PROJECT_MODULE.UI_STEP_FUNCTION_COMPONENT.SUBSCRIBED_EVENTS' | translate }}
        <rappider-icon class="info-icon"
                       nz-popover
                       nzPopoverPlacement="rightBottom"
                       [nzPopoverTitle]="FormItemsInfoMessages.subscribedEventsInfo.title"
                       [name]="infoIconConfig.name"
                       [color]="infoIconConfig.color"></rappider-icon>
      </nz-form-label>
      <nz-form-control [nzErrorTip]="requiredErrorTemplate"
                       [nzSpan]="calculateFormLayout().input">
        <rappider-select [options]="subscribedEventsSelectConfig.options"
                         [settings]="subscribedEventsSelectConfig.settings"
                         formControlName="subscribedEvents"
                         [disabled]="editUIStepFunctionForm?.get('subscribedEvents').disabled || editUIStepFunctionForm?.value.type === uIWorkflowItemTypeValues.PreDefinedTemplate"
                         (ngModelChange)="onSubscribedEventsChange()"></rappider-select>
      </nz-form-control>
    </nz-form-item>

    <nz-collapse nzGhost>
      <nz-collapse-panel nzHeader="Advanced Settings (Optional)"
                         [nzActive]="editUIStepFunctionForm?.value?.type === uIWorkflowItemTypeValues.ConfigurationDriven ? true : false">
        <!-- Type -->
        <nz-form-item>
          <nz-form-label [nzSpan]="calculateFormLayout().label">
            {{ 'SHARED.TYPE' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="requiredErrorTemplate"
                           [nzSpan]="calculateFormLayout().input">
            <rappider-select [options]="uiStepFunctionTypes"
                             formControlName="type"></rappider-select>
          </nz-form-control>
        </nz-form-item>

        <!-- Operation Type -->
        <nz-form-item *ngIf="editUIStepFunctionForm?.value.type === uIWorkflowItemTypeValues.ConfigurationDriven">
          <nz-form-label [nzSpan]="calculateFormLayout().label">
            {{ 'Integration Operator Type' | translate }}
            <rappider-icon class="info-icon"
                           nz-popover
                           nzPopoverPlacement="rightBottom"
                           [nzPopoverTitle]="FormItemsInfoMessages.integrationOperatorTypeInfo.title"
                           [name]="infoIconConfig.name"
                           [color]="infoIconConfig.color"></rappider-icon>
          </nz-form-label>
          <nz-form-control [nzErrorTip]="requiredErrorTemplate"
                           [nzSpan]="calculateFormLayout().input">
            <rappider-select [options]="uiStepFunctionIntegrationOperatorTypes"
                             [disabled]="editUIStepFunctionForm?.get('integrationOperatorType').disabled"
                             formControlName="integrationOperatorType"></rappider-select>
          </nz-form-control>
        </nz-form-item>

        <!-- Published Events On Success -->
        <nz-form-item *ngIf="editUIStepFunctionForm?.value.type === uIWorkflowItemTypeValues.ConfigurationDriven">
          <nz-form-label [nzSpan]="calculateFormLayout().label">
            {{ 'PROJECT_MODULE.UI_STEP_FUNCTION_COMPONENT.PUBLISHED_EVENTS_ON_SUCCESS' | translate }}
            <rappider-icon class="info-icon"
                           nz-popover
                           nzPopoverPlacement="rightBottom"
                           [nzPopoverTitle]="FormItemsInfoMessages.publishedEventsOnSuccessInfo.title"
                           [name]="infoIconConfig.name"
                           [color]="infoIconConfig.color"></rappider-icon>
          </nz-form-label>
          <nz-form-control [nzSpan]="calculateFormLayout().input">
            <rappider-ui-step-function-if-condition *ngIf="subscribedEventId || subscribedFieldIds; else selectSubscribedEvent"
                                                    (publishedEventSubmit)="onPublishedEventSubmit()"
                                                    formControlName="publishedEventsOnSuccess"
                                                    [subscribedEventId]="subscribedEventId"
                                                    [subscribedFieldIds]="subscribedFieldIds"
                                                    [disabled]="editUIStepFunctionForm?.get('publishedEventsOnSuccess').disabled"
                                                    [uiDataEvents]="uiDataEventOptions">
            </rappider-ui-step-function-if-condition>
            <ng-template #selectSubscribedEvent>
              {{
              'PROJECT_MODULE.UI_STEP_FUNCTION_CREATE_OR_EDIT_COMPONENT.PLEASE_SELECT_SUBSCRIBED_EVENTS_OR_DATA_SUBSCRIPTION'
              | translate
              }}
            </ng-template>
          </nz-form-control>
        </nz-form-item>

        <!-- Published Events Failure -->
        <nz-form-item *ngIf="editUIStepFunctionForm?.value.type === uIWorkflowItemTypeValues.ConfigurationDriven">
          <nz-form-label [nzSpan]="calculateFormLayout().label">
            {{ 'PROJECT_MODULE.UI_STEP_FUNCTION_COMPONENT.PUBLISHED_EVENTS_ON_FAILURE' | translate }}
            <rappider-icon class="info-icon"
                           nz-popover
                           nzPopoverPlacement="rightBottom"
                           [nzPopoverTitle]="FormItemsInfoMessages.publishedEventsOnFailureInfo.title"
                           [name]="infoIconConfig.name"
                           [color]="infoIconConfig.color"></rappider-icon>
          </nz-form-label>
          <nz-form-control [nzSpan]="calculateFormLayout().input">
            <rappider-select [options]="publishedEventsOnFailureSelectConfig.options"
                             [settings]="publishedEventsOnFailureSelectConfig.settings"
                             [disabled]="editUIStepFunctionForm?.get('publishedEventsOnFailure').disabled"
                             formControlName="publishedEventsOnFailure"></rappider-select>
          </nz-form-control>
        </nz-form-item>

        <!-- Subscribe to UI data store -->
        <nz-form-item *ngIf="editUIStepFunctionForm?.value.type === uIWorkflowItemTypeValues.ConfigurationDriven">
          <nz-form-label [nzSpan]="calculateFormLayout().label">
            UI Data Store Subscription
            <rappider-icon class="info-icon"
                           nz-popover
                           nzPopoverPlacement="rightBottom"
                           [nzPopoverTitle]="FormItemsInfoMessages.publishedEventsOnFailureInfo.title"
                           [name]="infoIconConfig.name"
                           [color]="infoIconConfig.color"></rappider-icon>
          </nz-form-label>
          <nz-form-control [nzSpan]="calculateFormLayout().input">
            <rappider-subscribe-to-ui-data-store formControlName="uiDataSubscriptionBody"
                                                 (publishedEventSubmit)="onPublishedEventSubmit()"
                                                 [uiDataStores]="uiDataStores"
                                                 [disabled]="editUIStepFunctionForm?.get('uiDataSubscriptionBody').disabled"
                                                 (ngModelChange)="onUIDataStoreSubscriptionChange()">
            </rappider-subscribe-to-ui-data-store>
          </nz-form-control>
        </nz-form-item>

        <!-- Step Function Mode Select -->
        <nz-form-item *ngIf="editUIStepFunctionForm?.value.type === uIWorkflowItemTypeValues.ConfigurationDriven">
          <nz-form-label [nzSpan]="calculateFormLayout().label">
            {{ 'Step Function Mode' | translate }}
          </nz-form-label>
          <nz-form-control [nzSpan]="calculateFormLayout().input">
            <rappider-select [ngModel]="uiWorkflowStepFunctionModeRadioGroupValue"
                             [options]="uiWorkflowStepFunctionModeRadioGroupOptions"
                             formControlName="mode"
                             (ngModelChange)="stepFunctionModeSelectValueChange($event)"></rappider-select>
          </nz-form-control>
        </nz-form-item>

        <!-- Project Model -->
        <nz-form-item
                      *ngIf="uiWorkflowStepFunctionModeRadioGroupValue === StepFunctionTypeOptions.Endpoint && editUIStepFunctionForm?.value.type === uIWorkflowItemTypeValues.ConfigurationDriven">
          <nz-form-label nzRequired
                         [nzSpan]="calculateFormLayout().label">
            {{ 'PROJECT_MODULE.UI_STEP_FUNCTION_CREATE_OR_EDIT_COMPONENT.PROJECT_MODEL_FOR_ENDPOINT' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="requiredErrorTemplate"
                           [nzSpan]="calculateFormLayout().input">
            <rappider-select [options]="projectModelOptions"
                             formControlName="projectModel"
                             [disabled]="editUIStepFunctionForm?.get('projectModel').disabled"
                             (ngModelChange)="onProjectModelValueChange($event)"></rappider-select>
          </nz-form-control>
        </nz-form-item>

        <!-- Endpoint ID -->
        <nz-form-item
                      *ngIf="uiWorkflowStepFunctionModeRadioGroupValue === StepFunctionTypeOptions.Endpoint && editUIStepFunctionForm?.value.type === uIWorkflowItemTypeValues.ConfigurationDriven">
          <nz-form-label nzRequired
                         [nzSpan]="calculateFormLayout().label">
            {{ 'PROJECT_MODULE.UI_STEP_FUNCTION_CREATE_OR_EDIT_COMPONENT.PROJECT_MODEL_ENDPOINT' | translate }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="requiredErrorTemplate"
                           [nzSpan]="calculateFormLayout().input">
            <rappider-select [options]="endpointOptions"
                             [disabled]="editUIStepFunctionForm?.get('endpointId').disabled"
                             formControlName="endpointId"></rappider-select>
          </nz-form-control>
        </nz-form-item>

        <!-- Custom Code -->
        <nz-form-item
                      *ngIf="uiWorkflowStepFunctionModeRadioGroupValue === StepFunctionTypeOptions.CustomCode && editUIStepFunctionForm?.value.type === uIWorkflowItemTypeValues.ConfigurationDriven">
          <nz-form-label [nzSpan]="calculateFormLayout().label">
            {{ 'SHARED.CODE' | translate }}
          </nz-form-label>
          <nz-form-control [nzSpan]="calculateFormLayout().input">
            <div style="height: 200px;">
              <rappider-monaco-code-editor [options]="monacoEditorSettings.editorOptions"
                                           [disabled]="editUIStepFunctionForm?.get('code').disabled"
                                           formControlName="code"></rappider-monaco-code-editor>
            </div>
          </nz-form-control>
        </nz-form-item>

        <!-- Services -->
        <nz-form-item
                      *ngIf="uiWorkflowStepFunctionModeRadioGroupValue === StepFunctionTypeOptions.WorkflowServices && editUIStepFunctionForm?.value.type === uIWorkflowItemTypeValues.ConfigurationDriven">
          <nz-form-label [nzSpan]="calculateFormLayout().label">
            {{ 'Rappider Services' }}
          </nz-form-label>
          <nz-form-control [nzSpan]="calculateFormLayout().input">
            <rappider-select [options]="serviceOptions"
                             formControlName="workflowServiceId"></rappider-select>
          </nz-form-control>
        </nz-form-item>

        <!-- Workflow Step Function -->
        <nz-form-item
                      *ngIf="uiWorkflowStepFunctionModeRadioGroupValue === StepFunctionTypeOptions.WorkflowStepFunctions && editUIStepFunctionForm?.value.type === uIWorkflowItemTypeValues.ConfigurationDriven">
          <nz-form-label [nzSpan]="calculateFormLayout().label">
            {{ 'Workflow Step Function' | translate }}
          </nz-form-label>
          <nz-form-control [nzSpan]="calculateFormLayout().input">
            <rappider-select [options]="workflowStepFunctionOptions"
                             formControlName="workflowStepFunctionId"></rappider-select>
          </nz-form-control>
        </nz-form-item>

        <!-- Server-side workflow event -->
        <nz-form-item
                      *ngIf="uiWorkflowStepFunctionModeRadioGroupValue === StepFunctionTypeOptions.WorkflowEvents && editUIStepFunctionForm?.value.type === uIWorkflowItemTypeValues.ConfigurationDriven">
          <nz-form-label [nzSpan]="calculateFormLayout().label">
            {{ 'Server-Side Workflow Events' }}
          </nz-form-label>
          <nz-form-control [nzSpan]="calculateFormLayout().input">
            <rappider-select [options]="serverSideWorkflowEventsOptions"
                             formControlName="workflowEventId"></rappider-select>
          </nz-form-control>
        </nz-form-item>
      </nz-collapse-panel>
    </nz-collapse>

    <!-- Submit Button -->
    <nz-form-item [ngClass]="isSubmitButtonFloat ? 'float-submit-button' : 'submit-button'">
      <nz-form-control [nzSpan]="calculateFormLayout().input">
        <button nz-button
                type="submit"
                nzType="primary"
                [nzLoading]="loading">
          {{ 'SHARED.SUBMIT' | translate }}
        </button>
      </nz-form-control>
    </nz-form-item>

    <!-- Error Templates -->
    <ng-template #nameFieldErrorTemplates>
      <small *ngIf="getNameFieldErrorsByErrorKey('required')">
        - {{ 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE' | translate }}
        <br />
      </small>
      <small *ngIf="getNameFieldErrorsByErrorKey('pattern')">
        - {{'ERRORS.PATTERN_MESSAGES.MUST_START_WITH_LOWERCASE_LETTER' | translate }}
      </small>
    </ng-template>
    <ng-template #requiredErrorTemplate>
      <small>
        - {{ 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE' | translate }}
      </small>
    </ng-template>
  </form>
</rappider-spin>
